import { getFinalPackageDisplayLabel } from './finalLetterPackages';
import { getMethodTypeLabel, normalizeBureau } from './letterTabLabel';

const METHOD_LABEL_OVERRIDES = {
  Recovery: 'Debt Validation',
  'Structural + Recovery': 'Structural Recovery Combo',
  'Isolated Method': 'Isolated',
};

/**
 * Sanitize a filename segment: spaces -> underscores, drop unsafe punctuation,
 * collapse duplicate underscores.
 */
export function sanitizeFilenameSegment(value) {
  return String(value || '')
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}

/**
 * Resolve the user-facing dispute method label for download filenames.
 */
export function resolveDisputeLetterMethodLabel(letterOrPackage = {}) {
  const fromPackage = getFinalPackageDisplayLabel(letterOrPackage);
  if (fromPackage && fromPackage !== 'Package') {
    const normalized = fromPackage.replace(/\s*\+\s*/g, ' ').trim();
    return METHOD_LABEL_OVERRIDES[normalized] || METHOD_LABEL_OVERRIDES[fromPackage] || normalized;
  }

  const fromLetter = getMethodTypeLabel(letterOrPackage);
  if (METHOD_LABEL_OVERRIDES[fromLetter]) {
    return METHOD_LABEL_OVERRIDES[fromLetter];
  }
  if (fromLetter && fromLetter !== 'Dispute Letter') {
    return fromLetter.replace(/\s*\+\s*/g, ' ').trim();
  }

  return null;
}

/**
 * Build dispute letter PDF download filename:
 * Dispute_Letter_<Bureau>_<Method>_<YYYY-MM-DD>.pdf
 */
export function buildDisputeLetterPdfFilename(letterOrPackage = {}, options = {}) {
  const bureau = normalizeBureau(
    letterOrPackage.bureau
      || letterOrPackage.target_bureau
      || letterOrPackage.targetBureau
      || 'Unknown'
  );
  const date = options.date || new Date().toISOString().split('T')[0];
  const methodLabel = resolveDisputeLetterMethodLabel(letterOrPackage);

  if (!methodLabel) {
    return `Dispute_Letter_${bureau}_Unknown_Method_${date}.pdf`;
  }

  const methodSegment = sanitizeFilenameSegment(methodLabel);
  return `Dispute_Letter_${bureau}_${methodSegment}_${date}.pdf`;
}
